import React from 'react';
import proptypes from 'prop-types';
const { string, bool } = proptypes;
import {
  params,
  arrayOf as arrayType,
  string as stringType,
  fragment,
  shape,
  customType,
  useDataModel
} from '@thd-nucleus/data-sources';
import { ProductShelfRenderer } from './ProductShelfRenderer';

const ProductShelf = ({
  componentId,
  componentClass,
  showTooFewProductsNotice,
  theme,
  homepageProductShelf
}) => {

  const {data, loading, error} = useDataModel('component', {
    variables: {
      id: componentId,
      componentClass
    }
  });

  if (!data || loading || error) {
    return null;
  }

  return (
    <ProductShelfRenderer
      componentId={componentId}
      dataComponent={data?.component}
      showTooFewProductsNotice={showTooFewProductsNotice}
      theme={data?.component?.theme || theme}
      homepageProductShelf={homepageProductShelf}
    />
  );
}

ProductShelf.propTypes = {
  componentId: string.isRequired,
  componentClass: string,
  showTooFewProductsNotice: bool,
  theme: string,
  homepageProductShelf: bool
};

ProductShelf.defaultProps = {
  componentClass: 'ProductShelf',
  showTooFewProductsNotice: false,
  theme: null,
  homepageProductShelf: false
};

ProductShelf.dataModel = {
  component: params({
    id: stringType().isRequired(),
    componentClass: customType('ComponentClass').enum(['ProductShelf']).isRequired()
  }).shape({
    ProductShelf: fragment().shape({
      id: stringType(),
      componentName: stringType(),
      sortBy: stringType(),
      publishDate: stringType(),
      sortOrderOptions: stringType(),
      theme: stringType(),
      title: stringType(),
      productShelfData: shape({
        navParam: stringType(),
        skus: arrayType(stringType())
      })
    })
  })
};

export { ProductShelf };
